import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import { SetMenu, MenuItem } from "../../../../redux/setMenuSlice";
import BreadCrumbs from "../../../../components/BreadCrumbs";
import "./index.css";
import ToggleSwitch from "../../../../components/ToggleSwitch";
import { getImageUrl } from "../../../../dummyData/FoodAttributes";

const ViewMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const item = location.state?.item as SetMenu;

  if (!item) {
    navigate("/");
    return null;
  }

  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <div className="set-menu-container">
        <Card className="set-menu-card">
          <CardHeader className="set-menu-card-header">
            <h5>Combo Menu Details</h5>
          </CardHeader>
          <CardBody>
            <div className="Container-set-menu-view">
              <img
                src={item.imageUrl}
                alt={item.displayName}
                className="set-menu-image-view"
              />
              <div className="setmenu-table-view">
                <table>
                  <tbody className="set-menu-table-item">
                    <tr>
                      <th>Name</th>
                      <td>{item.displayName}</td>
                    </tr>
                    <tr>
                      <th>Price (Rs.)</th>
                      <td>{item.price}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{item.description}</td>
                    </tr>

                    <tr>
                      <th>Category</th>
                      <td>{item.category}</td>
                    </tr>

                    <tr>
                      <th>Availability</th>
                      <td>
                        <ToggleSwitch
                          menuId=""
                          initialChecked={item.isAvailable}
                          disabled={true}
                        />{" "}
                      </td>
                    </tr>
                    {item.allergenInformation &&
                      item.allergenInformation.length > 0 && (
                        <tr>
                          <th>Allergen Information</th>
                          <td>
                            {item.allergenInformation.map((allergen, index) => (
                              <span
                                key={index}
                                className="d-inline-flex align-items-center"
                              >
                                <img
                                  src={getImageUrl(allergen)}
                                  alt={allergen}
                                  width={"20px"}
                                  height={"20px"}
                                  className="me-1 ms-2"
                                />
                              </span>
                            ))}
                          </td>
                        </tr>
                      )}
                    {item.foodAttributes && item.foodAttributes.length > 0 && (
                      <tr>
                        <th>Food Attributes</th>
                        <td>
                          {item.foodAttributes.map((attribute, index) => (
                            <span
                              key={index}
                              className="d-inline-flex align-items-center"
                            >
                              <img
                                src={getImageUrl(attribute)}
                                alt={attribute}
                                width={"20px"}
                                height={"20px"}
                                className="me-1 ms-2"
                              />
                            </span>
                          ))}
                        </td>
                      </tr>
                    )}

                    {/* Render supportPortionSizes if present */}
                    {item.supportPortionSizes !== undefined && (
                      <tr>
                        <th>Support Portion Sizes</th>
                        <td>
                          <ToggleSwitch
                            menuId=""
                            initialChecked={item.supportPortionSizes}
                            disabled={true}
                          />
                        </td>
                      </tr>
                    )}
                    <br />
                    {item.portions && item.portions.length > 0 && (
                      <tr>
                        <th>Portions</th>
                        <td>
                          <Table className="small-portions-table">
                            <thead>
                              <tr>
                                <th>Size</th>
                                <th>Price (Rs.)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.portions.map((portion, index) => (
                                <tr key={index}>
                                  <td>{portion.displayName}</td>
                                  <td>{portion.additionalCost}</td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <br />
            <h6 className="mt-4">Combo Menu's Menu Items</h6>
            <Table bordered responsive>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Item Name</th>
                  <th>Price (Rs.)</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {item.items.map((menuItem: MenuItem) => (
                  <tr key={menuItem.menuItemId}>
                    <td>
                      <img
                        src={menuItem.imageUrl}
                        alt={menuItem.displayName}
                        className="set-menu-item-image"
                      />
                    </td>
                    <td>{menuItem.displayName}</td>
                    <td>{menuItem.price}</td>
                    <td>{menuItem.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default ViewMenu;
